// extracted by mini-css-extract-plugin
module.exports = {"burger":"Burger_burger__K0UJL","burgerActive":"Burger_burgerActive__Zvd0c"};